module.exports = __webpack_public_path__ + "img/deposit.f60109eb.svg";